// import React, { useState } from "react";
// import Navbar from "../Navbar";
// import axios from "axios";
// import "rsuite/dist/rsuite.min.css";
// import { DateRangePicker } from "rsuite";
// import "../../scss/stats.scss";
// import LineChart from "../Charts/Stats/LineChart";
// import SelectSearchInput from "./../SelectSearch/index";
// import HandleRange from "./HandleRange";
// import Footer from "../Footer";

// const Stats = () => {
//   let url = process.env.REACT_APP_BASE_URL;
//   const [handleRange, setHandleRange] = useState(false);
//   const [selectDate, setSelectDate] = useState(false);
//   const [choseOutlet, setOutlet] = useState(false);
//   const [token, setToken] = useState("");
//   const [selectedOutlet, setSelectedOutlet] = useState("");
//   const [Total, setTotal] = useState([]);
//   const [labels, setLabels] = useState([]);
//   const [rangeType, setRangeType] = useState("");
//   const [startDate, setstartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const handleMonthly = () => {
//     setRangeType("monthly");
//     setHandleRange(true);
//     setOutlet(true);
//   };
//   const handleWeekly = () => {
//     setHandleRange(true);
//     setRangeType("weekly");
//     setOutlet(true);
//   };
//   const handleFreely = () => {
//     setHandleRange(true);
//     setRangeType("Free range");
//     setOutlet(true);
//   };

//   const handleDate = (e) => {
//     setSelectDate(true);
//     let newStartdate = new Date(e[0]);
//     let newEnddate = new Date(e[1]);
//     let start = newStartdate.toISOString().slice(0, 10);
//     setstartDate(start);
//     let end = newEnddate.toISOString().slice(0, 10);
//     setEndDate(end);
//     if (rangeType === "Free range") {
//       axios
//         .post(`${url}/datestats`, {
//           Outlet_Name: `${selectedOutlet}`,
//           start_date: `${start}`,
//           end_date: `${end}`,
//           token: `${token}`,
//         })
//         .then((response) => {
//           console.log(response.data);
//           setTotal(response.data.total);
//           setLabels(response.data.labels);
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//     if (rangeType && rangeType === "weekly") {
//       axios
//         .post(`${url}/chartsummary`, {
//           outlet: `${selectedOutlet}`,
//           start_date: `${start}`,
//           end_date: `${end}`,
//           type: `${rangeType}`,
//           token: `${token}`,
//         })
//         .then((response) => {
//           if (response?.data) {
//             setTotal(response.data.weeklyTotal);
//             setLabels(response.data.weeklydatelabel);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }

//     // console.log(rangeType)
//     if (rangeType && rangeType === "monthly") {
//       // console.log("here monthly")
//       axios
//         .post(`${url}/chartsummary`, {
//           outlet: `${selectedOutlet}`,
//           start_date: `${start}`,
//           end_date: `${end}`,
//           type: `${rangeType}`,
//           token: `${token}`,
//         })
//         .then((response) => {
//           if (response?.data) {
//             setTotal(response.data.monthlyTotal);
//             setLabels(response.data.monthlabel);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   };

//   return (
//     <div>
//       <Navbar />
//       <div className="stats-chart-width">
//         <div className="filter-margin">
//           <div className="select-search-radio">
//             <HandleRange
//               handleMonthly={handleMonthly}
//               handleWeekly={handleWeekly}
//               handleFreely={handleFreely}
//             />
//             <SelectSearchInput
//               setOutlet={setOutlet}
//               token={token}
//               setToken={setToken}
//               setSelectedOutlet={setSelectedOutlet}
//               selectedOutlet={selectedOutlet}
//             />
//             <DateRangePicker
//               onOk={(e) => handleDate(e)}
//               className="date-range-picker-margin"
//             />
//           </div>
//           <div className="selected-options">
//             <p className="filtered">Filtered</p>
//             {handleRange && (
//               <div className="range-type">
//                 <p>{rangeType}</p>
//               </div>
//             )}
//             {choseOutlet && (
//               <div className="selected-outlet-type">
//                 <p>{selectedOutlet}</p>
//               </div>
//             )}
//             {selectDate && (
//               <div className="start-end-date">
//                 <div className="range-type">
//                   <p>{startDate}</p>
//                 </div>
//                 <div className="range-type">
//                   <p>{endDate}</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//         <div className="bg-stats">
//           {Total && Total.length > 0 && labels && labels.length > 0 && (
//             <div className="stats-chart">
//               <div className="line-chart-stats">
//                 <LineChart
//                   labels={labels}
//                   Total={Total}
//                   labelTitle={rangeType}
//                   Title={"Stats"}
//                 />
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Stats;









import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import axios from "axios";
import LineChart from "../Charts/Stats/LineChart";
import SelectSearchInput from "./../SelectSearch/index";
import HandleRange from "./HandleRange";
import Footer from "../Footer";
import { toast } from "react-toastify";

const Stats = () => {
  let url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");

  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [Total, setTotal] = useState([]);
  const [labels, setLabels] = useState([]);
  const [rangeType, setRangeType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isSearched, setIsSearched] = useState(false);

  // Set today's date as default
  useEffect(() => {
    const today = new Date().toLocaleDateString('en-CA');
    setStartDate(today);
    setEndDate(today);
  }, []);

  const handleMonthly = () => {
    setRangeType("monthly");
  };

  const handleWeekly = () => {
    setRangeType("weekly");
  };

  const handleFreely = () => {
    setRangeType("Free range");
  };

  const handleView = async () => {
    if (!token || !selectedOutlet) return null;

    if (!startDate || !endDate || !rangeType) {
      toast.info("Please select all filters before viewing stats.");
      return null;
    }

    setIsSearched(true);
    setLoading(true);
    setError("");
    setTotal([]);
    setLabels([]);

    try {
      let response;

      if (rangeType === "Free range") {
        response = await axios.post(`${url}/datestats`, {
          Outlet_Name: selectedOutlet,
          start_date: startDate,
          end_date: endDate,
          token: token,
        });

        setTotal(response.data.total || []);
        setLabels(response.data.labels || []);
      }

      if (rangeType === "weekly") {
        response = await axios.post(`${url}/chartsummary`, {
          outlet: selectedOutlet,
          start_date: startDate,
          end_date: endDate,
          type: rangeType,
          token: token,
        });

        if (response?.data) {
          setTotal(response.data.weeklyTotal || []);
          setLabels(response.data.weeklydatelabel || []);
        }
      }

      if (rangeType === "monthly") {
        response = await axios.post(`${url}/chartsummary`, {
          outlet: selectedOutlet,
          start_date: startDate,
          end_date: endDate,
          type: rangeType,
          token: token,
        });

        if (response?.data) {
          setTotal(response.data.monthlyTotal || []);
          setLabels(response.data.monthlabel || []);
        }
      }
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.error ||
        err.data?.error ||
        "Something went wrong while fetching data. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />

      <div className="flex-grow">
        <div className="p-3">
          {/* Filters Section */}
          <div className="bg-white shadow-md max-w-6xl rounded-lg mx-auto px-8 py-4 mb-4">
            <div className="flex flex-wrap justify-between items-center">
              <HandleRange
                handleMonthly={handleMonthly}
                handleWeekly={handleWeekly}
                handleFreely={handleFreely}
              />

              <div className="flex flex-col justify-center">
                <div className="flex gap-10 items-center">
                  <div className="flex items-center gap-2">
                    <label className="font-base font-poppins md:text-base block">From:</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="px-3 py-2 border rounded-md focus:ring focus:ring-blue-300 focus:outline-none"
                    />
                  </div>

                  <SelectSearchInput
                    token={token}
                    setSelectedOutlet={setSelectedOutlet}
                    selectedOutlet={selectedOutlet}
                  />

                  <div className="flex items-center gap-2">
                    <label className="font-base font-poppins md:text-base block">To:</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="px-3 py-2 border rounded-md focus:ring focus:ring-blue-300 focus:outline-none"

                    />
                  </div>
                </div>

                <div className="flex justify-center mt-3">
                  <button
                    className="flex items-center gap-1 px-4 py-2 rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md text-sm"
                    onClick={handleView}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Results Section */}
          <div className="bg-white shadow-md rounded-lg max-w-6xl mx-auto min-h-[300px] flex items-center justify-center pb-14 mb-8">
            {loading && <p className="text-blue-600 font-medium">Loading data...</p>}

            {error && <p className="text-red-600 font-medium">{error}</p>}

            {!loading && !error && isSearched && Total && Total.length > 0 && labels && labels.length > 0 && (
              <div className="w-full">
                <LineChart
                  labels={labels}
                  Total={Total}
                  labelTitle={rangeType}
                  Title={"Stats"}
                />
              </div>
            )}

            {!loading && !error && isSearched && (!Total || Total.length === 0) && (
              <p className="text-gray-500 italic">No data available for the selected filters.</p>
            )}

            {!loading && !error && !isSearched && (
              <p className="text-gray-500 italic">Please select filters and click View to see stats.</p>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Stats;
